import * as Bixby from '$/core';

export interface LoginState {
  authenticated: boolean;
  isLoading: boolean;
  token?: string;
  decodedToken?: Bixby.Models.DecodedToken;
  error?: string;
  featureFlags?: string[];
  isRefreshModalOpen: boolean;
}

export interface TokenResult {
  token: string;
}

export const LOGIN_INPROGRESS = 'LOGIN_INPROGRESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_CLEAR_PRELOADED_DATA = 'LOGIN_CLEAR_PRELOADED_DATA';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const FEATURE_FLAGS_SUCCESS = 'FEATURE_FLAGS_SUCCESS';
export const LOGIN_MODAL_OPEN = 'LOGIN_MODAL_OPEN';
export const LOGIN_MODAL_CLOSE = 'LOGIN_MODAL_CLOSE';

interface LoginInProgress extends Bixby.Models.BixbyAction {
  type: typeof LOGIN_INPROGRESS;
}

interface LoginModalOpen extends Bixby.Models.BixbyAction {
  type: typeof LOGIN_MODAL_OPEN;
}

interface LoginModalClose extends Bixby.Models.BixbyAction {
  type: typeof LOGIN_MODAL_CLOSE;
}

interface LoginSuccess extends Bixby.Models.BixbyAction<TokenResult> {
  type: typeof LOGIN_SUCCESS;
  payload: TokenResult;
}

export interface LoginClearPreloadedData extends Bixby.Models.BixbyAction<TokenResult> {
  type: typeof LOGIN_CLEAR_PRELOADED_DATA;
  payload: TokenResult;
}

interface LoginFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError> {
  type: typeof LOGIN_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface LogoutSuccess extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError> {
  type: typeof LOGOUT_SUCCESS;
  payload: Bixby.Models.BixbyError;
}

interface FeatureFlagsSuccess extends Bixby.Models.BixbyAction<string[]> {
  type: typeof FEATURE_FLAGS_SUCCESS;
  payload: string[];
}

export type LoginActionTypes =
  | LoginInProgress
  | LoginSuccess
  | LoginFailure
  | LogoutSuccess
  | FeatureFlagsSuccess
  | LoginModalOpen
  | LoginModalClose;
